import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { clearBirthState } from "@/store/slices/birth";
import { loadLaborStages } from "@/store/slices/labor-stages";

interface UseResetLaborAmendOnContextChangeParams {
  encounterId?: string;
  clientId?: string;
}

/**
 * Clears amend-scoped client state when the route switches to a different patient or encounter.
 */
export function useResetLaborAmendOnContextChange({
  encounterId,
  clientId,
}: UseResetLaborAmendOnContextChangeParams): void {
  const dispatch = useDispatch();
  const previousEncounterContextRef = useRef<{ encounterId?: string; clientId?: string }>({});

  useEffect(() => {
    if (!encounterId || !clientId) {
      return;
    }

    const previous = previousEncounterContextRef.current;
    const hadPriorContext = Boolean(previous.encounterId && previous.clientId);
    const isContextSwitch =
      hadPriorContext && (previous.encounterId !== encounterId || previous.clientId !== clientId);

    previousEncounterContextRef.current = { encounterId, clientId };

    if (isContextSwitch) {
      dispatch(clearBirthState());
      dispatch(loadLaborStages([]));
    }
  }, [clientId, dispatch, encounterId]);
}
